/* eslint-disable no-multi-spaces */
/* eslint key-spacing: ["error", { align: "value" }] */

/**
 * Detect available browser input/output devices
 * and helper methods for management from the application.
 */
import debug from 'debug'
import LocalStorage from 'Store/class/local_storage'

class BrowserMedia {
  constructor () {
    this.dbg = debug('BrowserMedia:')
    this._devices = null
  }

  get isSupported () {
    return BrowserMedia.HasSupport()
  }

  static HasSupport () {
    return !!navigator.mediaDevices?.getUserMedia &&
      !!navigator.mediaDevices?.enumerateDevices &&
      ('setSinkId' in HTMLMediaElement.prototype)
  }

  get inputDevice () {
    return LocalStorage.matchInputDevice(this.getInputDevs())
  }

  get outputDevice () {
    return LocalStorage.matchOutputDevice(this.getOutputDevs())
  }

  get ringerDevice () {
    return LocalStorage.matchRingerDevice(this.getOutputDevs())
  }

  get ringingTone () {
    return LocalStorage.ringingTone()
  }

  get ringingVolume () {
    return LocalStorage.ringingVolume()
  }

  get isDevRingerOverrideEnabled () {
    return LocalStorage.isDevRingerOverrideEnabled()
  }

  async setDevices () {
    if (this._devices) {
      this.dbg('_setDevices: media devices are already set.')
      return
    }
    this._devices = []
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true, video: false })
      // need to get media to detect devices
      // but then need to close tracks to stop it
      // as it is not required anymore
      stream.getTracks().forEach(track => {
        track.stop()
      })
      const devs = await navigator.mediaDevices.enumerateDevices()
      for (const dev of devs) {
        if (!dev.deviceId || dev.kind.includes('video')) {
          continue
        }
        this._devices.push(dev)
      }
    } catch (error) {
      this.dbg('Failed to get media: %o', error)
    }
  }

  getInputDevs () {
    return this._getDevs('audioinput')
  }

  getOutputDevs () {
    return this._getDevs('audiooutput')
  }

  _getDevs (kind) {
    if (!this._devices) {
      this.dbg('_getDevs: not set devices')
      return []
    }
    const devs = []
    for (const d of this._devices) {
      if (d.kind === kind) {
        devs.push({ id: d.deviceId, label: d.label })
      }
    }
    return devs
  }
}

export default BrowserMedia
